<template>
  <div class="progress-circle-wrapper">
    <svg class="progress-circle" viewBox="0 0 44 44">
      <!-- Track de fondo -->
      <circle class="progress-circle__track" cx="22" cy="22" r="18"
        fill="none" stroke="#e5e7eb" stroke-width="4" />

      <!-- Arco de progreso real -->
      <circle v-if="status != 3"
        class="progress-circle__progress"
        cx="22" cy="22" r="18"
        fill="none"
        :stroke="progressColor"
        stroke-width="4"
        stroke-linecap="round"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="circumference * (1 - progress / 100)"
      />

      <!-- Arco animado giratorio (solo procesando) -->
      <circle v-if="isProcessing"
        class="progress-circle__spinner"
        cx="22" cy="22" r="18"
        fill="none"
        stroke="#3273dc"
        stroke-opacity="0.2"
        stroke-width="4"
        stroke-linecap="round"
        :stroke-dasharray="(circumference * 0.25) + ' ' + (circumference * 0.75)"
      />
    </svg>

    <!-- Centro: porcentaje, check o error -->
    <div class="progress-circle__label">
      <span v-if="status == 2" class="has-text-success">
        <b-icon pack="fas" icon="check" size="is-small" />
      </span>
      <span v-else-if="status == 3" class="has-text-danger">
        <b-icon pack="fas" icon="times" size="is-small" />
      </span>
      <span v-else class="progress-circle__percent" :style="{ color: percentTextColor }">{{ progress }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: { type: Number, default: 0 },
    status: { type: [Number, String], default: 0 },
    color: { type: String, default: 'blue' },
  },

  computed: {
    circumference() {
      return 2 * Math.PI * 18
    },
    isProcessing() {
      return this.status == 1 && this.progress < 100
    },
    colorHex() {
      const colors = {
        blue: '#3273dc',
        orange: '#f6993f',
        green: '#48c774',
      }

      return colors[this.color] || colors.blue
    },
    progressColor() {
      return this.status == 2 ? '#48c774' : this.colorHex
    },
    percentTextColor() {
      return this.status == 2 ? '#48c774' : this.colorHex
    },
  },
}
</script>

<style scoped>
.progress-circle-wrapper {
  position: relative;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
}

.progress-circle {
  width: 44px;
  height: 44px;
  transform: rotate(-90deg);
}

.progress-circle__progress {
  transition: stroke-dashoffset 0.4s ease;
}

.progress-circle__spinner {
  animation: spin 1.5s linear infinite;
  transform-origin: center;
}

.progress-circle__label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-circle__percent {
  font-size: 10px;
  font-weight: 600;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
